import { RequestGroup } from "@curai/js-fhir-tools";
import { z } from "zod";

export const testFormSchema = z.object({
  reminderDate: z.date().refine((date) => date > new Date(), {
    message: "Reminder date must be in the future",
  }),
  testNote: z.string().optional(),
});
export type TestFormData = z.infer<typeof testFormSchema>;

export const orderFormSchema = z
  .object({
    network: z.nativeEnum(RequestGroup.LAB_NETWORKS),
    billTo: z.nativeEnum(RequestGroup.BILLING_METHODS),
    orderNote: z.string().optional(),
    icd10Codes: z.array(
      z.object({
        code: z.string(),
        display: z.string(),
        version: z.string(),
      }),
    ),
    compendiumId: z.string().optional(),
    tests: z.record(z.string(), testFormSchema).optional(),
  })
  .refine(
    (data) => {
      if (data.billTo === RequestGroup.BILLING_METHODS.INSURANCE) {
        return data.icd10Codes?.length > 0;
      }
      return true;
    },
    {
      message: "ICD-10 codes are required to bill to insurance",
      path: ["icd10Codes"],
    },
  );

export type OrderFormData = z.infer<typeof orderFormSchema>;
